<!--
 * @Author: Gaho
 * @Date: 2023-12-14 13:34:24
 * @LastEditors: Merlin
 * @LastEditTime: 2024-12-09 15:00:06
 * @Description: 
-->
<template>
    <ModalTitle
        container-class=""
        :model-value="modelValue"
        :backdrop="backdrop"
        @update:model-value="onModelValue"
    >
        <template #header>
            <span class="text-[24px] leading-10">
                {{ `📑${$t('GameRules')}` }}
            </span>
        </template>
        <!-- 
            ↑ 顶部标题
            ↓ 窗口内容主体 
        -->
        <div class="w-full flex flex-col gap-3 text-white"
            :now-page="sShowingPage"
        >
            <ButtonRulesTopTab
                v-if="aTabList.length"
                v-model="sCurTab"
                :tab-list="aTabList"
            ></ButtonRulesTopTab>
            <!-- ↑复杂页签，↓简单页签 -->
            <ButtonToggle
                v-else
                v-model="isLimit"
                :enable-text="$t('Limits')"
                :disable-text="$t('Rules')"
            ></ButtonToggle>
            <!-- ↑ 上方切换的页签 -->
            <!-------------------------------------------------->
            <!-- ↓ 下方变换的内容主体 -->
            <div class="flex flex-col gap-3"
                v-if="isShowSlide"
            >
                <!-- 说明： navigation 属性用于控制下方小圆点的可见性 ●●●● -->
                <QCarousel
                    v-if="isShowPicsOfSlide"
                    swipeable
                    animated
                    arrows
                    :navigation="aSlidesArr.length > 1" 
                    v-model="slide"
                    control-color="primary"
                    transition-prev="slide-right"
                    transition-next="slide-left"
                    :height="`${iPicHeight + 0}px`"
                    :height-value="iPicHeight"
                    class="transparent the-slider"
                >
                    <q-carousel-slide
                        class="!rounded-2xl"
                        v-for="(carousel, index) in aSlidesArr"
                        :style="{padding: 0}"
                        :name="index + 1"
                        :key="index"
                    >
                        <q-img class="rounded-borders col-6 full-height"
                            :src="carousel.imgToShow" 
                        />
                    </q-carousel-slide>
                </QCarousel>
                <!-- 
                    ↑ 轮播图（Mini 版中有少数游戏有这项）
                    ↓ 轮播图当前页对应的文字描述
                -->
                <p v-if="aSlidesArr[slide - 1]?.content1"
                    class="text-sm text-white w-full "
                    :class="{
                        [isShowPicsOfSlide ? 'py-0': 'py-6 leading-6']: true, 
                    }"
                >
                    {{ $t(aSlidesArr[slide - 1].content1) }}
                    <br />
                    {{ aSlidesArr[slide - 1]?.constent2 && $t(aSlidesArr[slide - 1].constent2) }}
                </p>
                <!-- ↓ 翻页按钮/开始游戏按钮 -->
                <template v-if="!aTabList.length">
                    <!-- <ButtonThe3DButton
                        vvif="aSlidesArr.length !== slide"
                        color="blue" size="lg" full-width
                        @click="onNextClick"
                    >
                        {{ $t('Next') }}
                    </ButtonThe3DButton> -->
                    <!--
                        ● 此处上下2个按钮互斥存在，在 Mini 版的新需求下，仅保留下方一个
                        ● 注释上方的，进行观察期，将来删除。于 2024.07.16 10:2:16 星期二  
                    -->
                    <ButtonThe3DButton
                        color="blue"
                        size="lg"
                        full-width
                        @click="onModelValue(false)"
                    >
                        {{ $t('StartPlaying') }}
                    </ButtonThe3DButton>
                </template>
            </div>
            <!-- ↑ 轮播图 -->
            <!-- ↓ 子页：限制 -->
            <ModalRulesLimitComponent 
                v-else-if="sShowingPage === Limits.label"
            />
            <!-- ↓ 子页：文本类型的游戏规则 -->
            <ModalRulesRuleText
                :gameName="gameName"
                v-else-if="sShowingPage === rules.label"
            ></ModalRulesRuleText>
            <!-- ↓ 子页： roulette 专用 -->
            <ModalRulesRulePayouts
                v-else-if="sShowingPage === payouts.label" 
            ></ModalRulesRulePayouts>
            <!-- ↓特定游戏下方的统一按钮，红按钮 -->
            <div class="abc"
                v-if="aTabList.length > 0"
            >
                <ButtonThe3DButton
                    color="red"
                    size="lg"
                    full-width
                    @click="onModelValue(false)"
                >
                    {{ $t('startPlaying') }}
                </ButtonThe3DButton>
            </div>
        </div>
    </ModalTitle>
</template>

<script lang="ts" setup>
import useGlobalStore from '@/stores/global';
import type { PropType } from 'nuxt/dist/app/compat/capi';
import 'quasar/src/components/carousel/QCarousel.sass';

export interface CarouselsType {
    content1: string;
    constent2?: string;
    img: string; // 原有的桌面端图片
    imgMobile?: string; // 后加的移动端图片
    imgToShow?: string; // 按屏幕尺寸选择以上图片中的一个
}

export type CarouselsArray = Array<CarouselsType>;

const sCurTab = ref(''); // 当前页签 
const isLimit = ref(false);
const slide = ref(1);
const oGlobalStore = useGlobalStore();

const props = defineProps({
    modelValue: Boolean, // 
    gameName: String,
    backdrop: {
        type: Boolean,
        default: true,
    },
    // rules图片和content数据
    carousels: {
        type: Array as PropType<CarouselsArray>,
        default: () => [],
        required: true,
    },
    // pay lines 图 
    paylinesPic: {
        type: Array as PropType<CarouselsArray>,
        default: () => [],
    },
});

// ↓ 注意： label 的值是 i18n 的键 
const howDoesGameStart = {label: 'howDoesGameStart', icon: 'icon-table-page'}; // 怎么玩1
const howRouletteStart = {...howDoesGameStart, icon: 'icon-book'}; // 怎么玩2
const payTable = {label: 'payTable', icon: 'icon-table-page'}; // 赔付表 
const payouts = {label: 'payouts', icon: 'icon-table-page'}; // 赔付表 
// ↑ 以上2项都是显示游戏玩法图的页面，只是名称不一样，内容雷同（不会在某一游戏同时出现其中的2项）
// ↓ 少数游戏会用到的内容
const rules = {label: 'rules', icon: 'icon-book'}; // 规则（大面积文本内容）
const Limits = {label: 'Limits', icon: 'icon-database'}; // 限制 （传统限制页）
const payLines = {label: 'payLines', icon: 'icon-paylines'}; // 中奖线（图）

// ↓ 记录特定游戏都显示哪些页签 
const oLib = {
    roulette: [howRouletteStart, payouts, Limits],
    crash: [rules, howDoesGameStart, Limits],
    blackjack: [howDoesGameStart, rules, Limits],
    corgipharaoh: [rules, payTable, payLines, Limits],
    dice: [rules, Limits],
};


// ↓当前游戏的页签
const aTabList  =  computed(()=>{
    console.log("props.gameName", props.gameName); 
    // ↓有可能取不到值，属正常现象，取不到值，说明处于传统状态，只有2个页：轮播图+限制页 
    const arr = oLib[props.gameName];
    return arr || [];
});


// ↓ 当前页名称（按此显示弹窗内的小组件） 
const sShowingPage = computed(()=>{
    if (aTabList.value.length){
        return sCurTab.value; 
    }
    // ↑多个页签，↓2个页签
    if (isLimit.value) return Limits.label;
    return howDoesGameStart.label; 
});


// ↓ 控制是否显示轮播图页面 
const isShowSlide = computed(()=>{
    if (!aTabList.value.length){
        return !isLimit.value; // 不在限制页，则在图片页 
    }
    const a2ShowSlide = [
        howDoesGameStart.label,
        howRouletteStart.label,
        payTable.label,
        payLines.label,
    ];
    return a2ShowSlide.includes(sCurTab.value);
});

// ↓ 控制是否显示轮播图之图💥
const isShowPicsOfSlide = computed(()=>{
    const arr01 = [
        'corgipharaoh',
    ];
    const bResult = (
        arr01.includes(props.gameName)
        && !!aSlidesArr.value.find(cur => cur.imgToShow)
    );
    return bResult;
});


// ↓ 计算当前是否为移动端状态  
const isMobileMode  =  computed(()=>{
    const {innerWidth} = oGlobalStore;
    // ↓ 移动端标记（数值 “400” 等同原站点）
    const isMobileMode = innerWidth <= 400; 
    return isMobileMode;
});

// ↓ 用于轮播的图
// ↓ 在桌面端和移动端显示不同的内容）
const aSlidesArr = computed(() => {
    let arr = props.carousels;
    // ↓ 使轮播图显示【中奖线】的图 --------------------
    if (props.gameName == 'corgipharaoh' && sCurTab.value == payLines.label){
        arr = props.paylinesPic;
    }
    const aResult = arr.map((cur) => {
        cur.imgToShow = cur.img;
        // ↓ 切换为移动端图片
        if (isMobileMode.value && cur.imgMobile){
            cur.imgToShow = cur.imgMobile;
        }
        return cur;
    });
    return aResult;
});


const emit = defineEmits(['update:modelValue']);
const onNextClick = () => {
    slide.value += 1;
};


// ↓监听窗口打开
watch(()=>props.modelValue, async (isShowing)=>{
    if (!isShowing) return;
    if (aTabList.value.length){
        sCurTab.value = aTabList.value[0]?.label;
    }else{
        sCurTab.value = '';
    }
    // console.log("isShowing: ", isShowing, sCurTab.value);
});

// 图片高
const iPicHeight = ref(300);
// 图片宽
const iPicWidth = computed(()=>{ 
    const {innerWidth} = oGlobalStore;
    if (innerWidth <= 550) {
        return innerWidth - (32 * 2); // 减去两侧边距 
    }
    return 482;
});

watch([
    aSlidesArr,
    isMobileMode, // 加入监听，以触发更新 
    ()=> props.modelValue, // 加入监听，以触发更新
], async (aNewData)=>{
    const [carousels=[], isMobileMode, isShowing] = aNewData;
    const aSkitp = [
        isShowing == false,
        !carousels.find(cur=>cur.imgToShow),
        !import.meta.client,
    ];
    if (aSkitp.some(Boolean)) return;
    const arr = carousels.map(cur=>{
        let resolve;
        const oPromise = new Promise((f1,f2)=> resolve=f1);
        Object.assign(new Image(), {
            src: cur.imgToShow,
            onload(ev){
                const {width, height} = ev.target;
                resolve({width, height});
            },
        });
        return oPromise;
    });
    const aResult01 = await Promise.all(arr);
    const aResult02 = aResult01.map(cur => {
        const multiple = iPicWidth.value / cur.width;
        return multiple * cur.height;
    });
    iPicHeight.value = Math.max(...aResult02);
    // console.log("新高度", iPicHeight.value);
});

const onModelValue = (value) => {
    // console.log('收到新值：', value); 
    emit('update:modelValue', value); 
};
</script>


<style lang="scss" scoped>
.the-slider :deep(.q-carousel__control){
    bottom: -8px;
}


</style>


